"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
var START_FRAGMENT = '<!--StartFragment-->';
var END_FRAGMENT = '<!--EndFragment-->';
var NBSP_HTML = '\u00A0';
exports.createPasteFragment = function (core, clipboardData, position, pasteAsText, applyCurrentStyle) {
    var _a, _b;
    // Step 1: Prepare BeforePasteEvent object
    var event = createBeforePasteEvent(core, clipboardData, pasteAsText);
    var fragment = event.fragment, pasteOption = event.pasteOption, sanitizingOption = event.sanitizingOption;
    var rawHtml = clipboardData.rawHtml, text = clipboardData.text, imageDataUri = clipboardData.imageDataUri;
    var doc;
    // Step 2: Fill the BeforePasteEvent object, especially the fragment for paste
    if (pasteOption == 2 /* PasteImage */ && imageDataUri) {
        var img = core.document.createElement('img');
        img.style.maxWidth = '100%';
        img.src = imageDataUri;
        fragment.appendChild(img);
    }
    else if (pasteOption == 0 /* PasteHtml */ &&
        rawHtml && ((_a = (doc = new DOMParser().parseFromString(rawHtml, 'text/html'))) === null || _a === void 0 ? void 0 : _a.body)) {
        // Save HTML node attributes and META attributes so that plugin can query
        var attributes = (_b = doc.querySelector('html')) === null || _b === void 0 ? void 0 : _b.attributes;
        (attributes ? roosterjs_editor_dom_1.toArray(attributes) : []).reduce(function (attrs, attr) {
            attrs[attr.name] = attr.value;
            return attrs;
        }, event.htmlAttributes);
        roosterjs_editor_dom_1.toArray(doc.querySelectorAll('meta')).reduce(function (attrs, meta) {
            attrs[meta.name] = meta.content;
            return attrs;
        }, event.htmlAttributes);
        // Move all STYLE nodes into header, and save them into sanitizing options.
        // Because if we directly move them into a fragment, all sheets under STYLE will be lost.
        processStyles(doc, function (style) {
            doc.head.appendChild(style);
            sanitizingOption.additionalGlobalStyleNodes.push(style);
        });
        var startIndex = rawHtml.indexOf(START_FRAGMENT);
        var endIndex = rawHtml.lastIndexOf(END_FRAGMENT);
        if (startIndex >= 0 && endIndex >= startIndex + START_FRAGMENT.length) {
            event.htmlBefore = rawHtml.substr(0, startIndex);
            event.htmlAfter = rawHtml.substr(endIndex + END_FRAGMENT.length);
            doc.body.innerHTML = clipboardData.html = rawHtml.substring(startIndex + START_FRAGMENT.length, endIndex);
            // Remove style nodes just added by setting innerHTML of body since we already have all
            // style nodes in header.
            // Here we use doc.body instead of doc because we only want to remove STYLE nodes under BODY
            // and the nodes under HEAD are still used when convert global CSS to inline
            processStyles(doc.body, function (style) { var _a; return (_a = style.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(style); });
        }
        while (doc.body.firstChild) {
            fragment.appendChild(doc.body.firstChild);
        }
        if (applyCurrentStyle && position) {
            var format_1 = getCurrentFormat(core, position.node);
            roosterjs_editor_dom_1.applyTextStyle(fragment, function (node) { return roosterjs_editor_dom_1.applyFormat(node, format_1); });
        }
    }
    else if (text) {
        text.split('\n').forEach(function (line, index, lines) {
            line = line
                .replace(/^ /g, NBSP_HTML)
                .replace(/\r/g, '')
                .replace(/ {2}/g, ' ' + NBSP_HTML);
            var node = line == '' ? document.createElement('br') : document.createTextNode(line);
            fragment.appendChild(index == 0 || index == lines.length - 1 ? node : roosterjs_editor_dom_1.wrap(node));
        });
    }
    // Step 3: Trigger BeforePasteEvent so that plugins can do proper change before paste
    core.api.triggerEvent(core, event, true /*broadcast*/);
    // Step 4. Sanitize the fragment before paste to make sure the content is safe
    var sanitizer = new roosterjs_editor_dom_1.HtmlSanitizer(event.sanitizingOption);
    sanitizer.convertGlobalCssToInlineCss(fragment);
    sanitizer.sanitize(fragment, position && roosterjs_editor_dom_1.getInheritableStyles(position.element));
    return fragment;
};
function getCurrentFormat(core, node) {
    var pendableFormat = roosterjs_editor_dom_1.getPendableFormatState(core.document);
    var styleBasedForamt = core.api.getStyleBasedFormatState(core, node);
    return {
        fontFamily: styleBasedForamt.fontName,
        fontSize: styleBasedForamt.fontSize,
        textColor: styleBasedForamt.textColor,
        backgroundColor: styleBasedForamt.backgroundColor,
        textColors: styleBasedForamt.textColors,
        backgroundColors: styleBasedForamt.backgroundColors,
        bold: pendableFormat.isBold,
        italic: pendableFormat.isItalic,
        underline: pendableFormat.isUnderline,
    };
}
function createBeforePasteEvent(core, clipboardData, pasteAsText) {
    var pasteOption = pasteAsText
        ? 1 /* PasteText */
        : clipboardData.text || !clipboardData.image
            ? 0 /* PasteHtml */
            : 2 /* PasteImage */;
    var fragment = core.document.createDocumentFragment();
    return {
        eventType: 9 /* BeforePaste */,
        clipboardData: clipboardData,
        pasteOption: pasteOption,
        fragment: fragment,
        sanitizingOption: roosterjs_editor_dom_1.createDefaultHtmlSanitizerOptions(),
        htmlBefore: '',
        htmlAfter: '',
        htmlAttributes: {},
    };
}
function processStyles(node, callback) {
    var styles = node.querySelectorAll('style');
    for (var i = 0; i < styles.length; i++) {
        callback(styles[i]);
    }
}
//# sourceMappingURL=createPasteFragment.js.map